
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqGig8ckO1tIb82QmGVmxi6SOEosBWkzEJVAaHhz6W_BsMeta } from "/codebuild/output/src3405017696/src/src/pages/faq.vue?macro=true";
import { default as menuWri9LUNE_45JinoMXQ8v8Hd93sbb68vVokhnysiUJ4Cw8Meta } from "/codebuild/output/src3405017696/src/src/pages/menu.vue?macro=true";
import { default as index8aY88rYyAaosfG6AAWndblSgwGfrnCQPKEQsLL9c2zcMeta } from "/codebuild/output/src3405017696/src/src/pages/index.vue?macro=true";
import { default as contactrAARUB7bCaT4FcPjazOIBXrM_stFLCnEqNxx5Fc4024Meta } from "/codebuild/output/src3405017696/src/src/pages/contact.vue?macro=true";
import { default as tutorialn_gd0PD37rBI_qwWChDw_6AdGBzZGzJZ0YFaTkLFyDsMeta } from "/codebuild/output/src3405017696/src/src/pages/tutorial.vue?macro=true";
import { default as agreement0I0p0_fGfUztyRYeK4nPDguwRzsxJVq2amwj2eoOSdMMeta } from "/codebuild/output/src3405017696/src/src/pages/agreement.vue?macro=true";
import { default as about_45passLe_45_45m616_CDz6aa_45dlD6z_lukiCMVM0gnDYoiUYM9vIMeta } from "/codebuild/output/src3405017696/src/src/pages/about-pass.vue?macro=true";
import { default as indexk8D5X_45LNmOi4R_5IdeW8Jh27aHwqfDOGrx1UTEWntG0Meta } from "/codebuild/output/src3405017696/src/src/pages/card/index.vue?macro=true";
import { default as _91id_935aFrdjRP8J7JVavz4uApRIp2yHhrk39Y8RDlomv7_uwMeta } from "/codebuild/output/src3405017696/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenancetOrOiBWwsBrzsx0pBeFjRdo6eeOQYymeXs6DWDuAHK0Meta } from "/codebuild/output/src3405017696/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93AETFUqOhtT2iyaVekigm6JFHRag4XfhxdcWbeYap0hAMeta } from "/codebuild/output/src3405017696/src/src/pages/notice/[id].vue?macro=true";
import { default as indexwpE1mO1GA_45Hzzz7Z_45a_45uXNoMn7sqQ98kZu1rSdP5XE8Meta } from "/codebuild/output/src3405017696/src/src/pages/coupon/index.vue?macro=true";
import { default as index_kMp61YXNYo90G0CJY4ZnApAWmmcsfRagIG5NlWRZpMMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/index.vue?macro=true";
import { default as index9X79HbI1EeLdpgxyrnr5mO91fY4l_ADsUoywXbDvng0Meta } from "/codebuild/output/src3405017696/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_932vwW_RyWQMk20nzsZr3dn0HhKdZJmDdumCzXB4FZKigMeta } from "/codebuild/output/src3405017696/src/src/pages/parking/[id].vue?macro=true";
import { default as indexw9gjsBSNlKrhSJFv41LLcLy0mNJAsx4606u2dspV1HMMeta } from "/codebuild/output/src3405017696/src/src/pages/history/index.vue?macro=true";
import { default as indexcxMjwopSQ7Nyrgy6Ub9U9CS6WV_45Hm_45lsyB0IhYJjhj0Meta } from "/codebuild/output/src3405017696/src/src/pages/monthly/index.vue?macro=true";
import { default as indexKHu3Dy2FYkZd__dRNxIf9phwz1JfFAD0Yy1hq6g5I5MMeta } from "/codebuild/output/src3405017696/src/src/pages/sign-in/index.vue?macro=true";
import { default as index97LbbCbY0dBIYWYe8uMjypuGho_45gsid5ISthPyrllg0Meta } from "/codebuild/output/src3405017696/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviuosh10QNoX8et5t8wljRlz6k4nKHe2EjuvqKVlhFce0Meta } from "/codebuild/output/src3405017696/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editnRauhxHAL4gJ3rqoMr3QwDsigFebtfaPaTJbgIxX0CYMeta } from "/codebuild/output/src3405017696/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementb9VYTFaeIuLa1vPqwO_45MMSegWDfJ6mditMq9g8XyGfoMeta } from "/codebuild/output/src3405017696/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexJL8YcjMpJr4TQiBBsKJacXyrUdVcGdHQHvNbL4hsj9UMeta } from "/codebuild/output/src3405017696/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d4USRVt3zJ9LAYZW4xqD8XBfTkHxhd3STgM8Pua2Ou4EMeta } from "/codebuild/output/src3405017696/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmqhNAZ3ZyX0eUVebYpFzt8YU6IK1TG_lM4I2T_XFyuwQMeta } from "/codebuild/output/src3405017696/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexXsYi_LDkoaI0pCpBTOZl5cGylMFum7altCw3UKZyBhIMeta } from "/codebuild/output/src3405017696/src/src/pages/card/create/index.vue?macro=true";
import { default as indextD9ISy7cdo6kfwZofITcJCORskimpv_HlqkPvKbrunwMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmFI4zpqhsftO7TZdrJaDGsTtQq0C0HO0WsGdi_45R9BTMcMeta } from "/codebuild/output/src3405017696/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmHOzaMVWMbIj54oPPEtTRjvEpqIP2NjVooyWGZDF6eBsMeta } from "/codebuild/output/src3405017696/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completedko1ktByvOrZo7LXxf3BdgA11fVs5vgiyHF7xsJRQOkMeta } from "/codebuild/output/src3405017696/src/src/pages/membership/complete.vue?macro=true";
import { default as registerX_qe0R1yiUa1SnRFSnPbO3eqFESxn_SBZdNBL5XwOIgMeta } from "/codebuild/output/src3405017696/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_930eyN6RF_rHdBoqfxe7euf8qoq1fDLwXLJsOVT315sW4Meta } from "/codebuild/output/src3405017696/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmmCV9rEnPy2EsBOWlSGJW_hP0u68kZqO_4599Wc3CME3j4Meta } from "/codebuild/output/src3405017696/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93G_FYNzG3haBaoPj0Xxh0Vwc1duWcE1ab029aoGqQ05YMeta } from "/codebuild/output/src3405017696/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexOAJVtbVP8EL1kXv_fCRdxkEvVlbgt_l8ZHeE7VmDNdAMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codefxvMmXqQDvvHIc6anyPNzV5NQISPLzoJMAl2uzqwwg0Meta } from "/codebuild/output/src3405017696/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeVLpNp_wo1dmp0tnNOWLaYg1QbhvmI2jINRFE5pWc9TIMeta } from "/codebuild/output/src3405017696/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeaGCkXFxCh6MWSmnfYmRvOTo7T6i6Gw0EfjQobRDcGckMeta } from "/codebuild/output/src3405017696/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registertoVxlpChC2NexQufy0JErAPFY33ocEtIDBjH3_6gceQMeta } from "/codebuild/output/src3405017696/src/src/pages/contact-form/register.vue?macro=true";
import { default as completex7LnGepIiNOD68WoFz4mvy3CNALu5Ba0S_oUE6hNhxQMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexlF7xfbUQuVf3G1qYqSbIpM3bnToa3SaCuSz3l6v77JYMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmA8hD1UvSKYZbZBhvIVI2XcZ8Rl1lt2u0ZaBvwsEGpaUMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeNAhaNh9lsuDKPGRPjgvYqwwIU5tsjD6PSzxNFfjdMfQMeta } from "/codebuild/output/src3405017696/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexsWNbxnu4GNTFRJUCFgSOzb6HZmua_45sTqhZkKytERPgwMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93pd_450wrDYYb881bF4IFA6UqgBjvujKqckBQO4uXGTfewMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete8SgzySZFFpgBMbBr4TeMh6YCq5KVYAM_C5UGEVxJkMoMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasw_BJPkHeHw3HtlCPSF9rjul2U_45shxQO6t2VBuygD8dwMeta } from "/codebuild/output/src3405017696/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleISF_ANCrjeAt5Lt8O9SgB67SjfMaPnXZ9ITdr7cV0vMMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailGdebheBq9ELZbGPfnUIUv_45Xq4KqGDUL9BM5rk_45trJ1MMeta } from "/codebuild/output/src3405017696/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmW3fPKwcgDjkgbT8kNflxgYq24G_45a8poz9aooWiBNKpQMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent_45tKKbORQRfM5YaxrCJX5MtOZhALcWkh_45YW_WbWOCTpcMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmPEL9NCPEvFk5FI_sT_0AR6Nk7x_r5Z7OeQTE4ZzxUMwMeta } from "/codebuild/output/src3405017696/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatetvw18VLGA4Fi9Ww_45uT5vL7sU6dz4yTkMJGIYu0SeRQwMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completen7gJZ7JlvtKnrKrOVZHF5g87eEnGWrPOk3TiY_RK0ZcMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeQrpPRZQfk5LA6qC7YVLR6tTteQKrMF0oawMoitKcXqMMeta } from "/codebuild/output/src3405017696/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordl7huRKBjMZCvBYcxpTCakRjRdAOKom8ECmbBhq4I418Meta } from "/codebuild/output/src3405017696/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliaszuI0wREa0JqGHnz8I_458fFYehqDuHkGDKhF72Ka1YOu0Meta } from "/codebuild/output/src3405017696/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerH6HDrxZYOTvU2Nsf9hAwU_bonr_45nUCTLsIDg2L0k3d8Meta } from "/codebuild/output/src3405017696/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeWLRU3_45964V2fccMTJT2h_Q_45SH5wn84I8OS1RiUF2yc0Meta } from "/codebuild/output/src3405017696/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexuDpynGzUfMHcSNUaj_PLlnZ_45Rxo_JVtPV5A2u_45GQqA0Meta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexDpd49xhhSXbf8PGy9cJ1qJUzeCILxL34n9hTM2mkz9UMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexC3HeClNbfZjZynLMJHMhnZ9BlCDlROV7dzGB7Ci9xFoMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexjcAGl0_aJ62rZvyRX19zLjPknXUbLdVVowFqPPQ7RnEMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update3bJU2bRu6NK4WHToNGxawD5f9DWGJOuQWjW8T9SO0coMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeXp9arfUE2tFeEdQaNdhA3AWnF6aKx2UsuIxFV5TCRXEMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmozRjtfXv4DcJ5X7_45NUUQFMP5tzhdHSV3vV3glWWIQg4Meta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index3amRXJ9kLiIESqZ1m5lGs_gLMI5mKkrksEKkt4oKit4Meta } from "/codebuild/output/src3405017696/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as complete8pPZT4_45ra3lzyDPSXGemnMC7LWZukkBYuZs77pJgJzAMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateyHLvcmz20zhpxPKMu8s7q_45I15RtSU17T4E7vOyyJFM8Meta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexy0gozEQ64oRkxrpiuk7L_45655IRnJwuDCM4VsqdmQMW0Meta } from "/codebuild/output/src3405017696/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexoPlq8wViNWtx6k7ALGiQlyEwwRMrQc8V6m9ugSd4_5wMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeugBhcIXVj5FOS9hMxSJxvdINsnVl9JzYgNVNkVZEqawMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexoyshUhD45IVg1xHImcjG6Sicphvv4a4l0xiXNfFjKmYMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codejoZGEscEEqWi28NkL_45OdxOq_4596cg5AlyO_45d7CE48ypUMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index4vaNV40jHbucIdjdHszMqDdYL8gqdUH1W9kbivF_45MTwMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexiUwBZqMCAR2J_70e1w3E_45ei5RvhOWnOJqeyPBsmvvGEMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexHPRTwDP_FTQC37Sr5souJRrSFRcinxn0ULZB8dNRzacMeta } from "/codebuild/output/src3405017696/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateRyNuM43GsiSElxQvY_456c7SOj2ZFngIZ2EsCauqM4bFEMeta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmOcDnAmT3dVSNvIiGdKhTu1ldnktIifnwsT8k9mR7Sv4Meta } from "/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuWri9LUNE_45JinoMXQ8v8Hd93sbb68vVokhnysiUJ4Cw8Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: index8aY88rYyAaosfG6AAWndblSgwGfrnCQPKEQsLL9c2zcMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexwpE1mO1GA_45Hzzz7Z_45a_45uXNoMn7sqQ98kZu1rSdP5XE8Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexw9gjsBSNlKrhSJFv41LLcLy0mNJAsx4606u2dspV1HMMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexKHu3Dy2FYkZd__dRNxIf9phwz1JfFAD0Yy1hq6g5I5MMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index97LbbCbY0dBIYWYe8uMjypuGho_45gsid5ISthPyrllg0Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexXsYi_LDkoaI0pCpBTOZl5cGylMFum7altCw3UKZyBhIMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmFI4zpqhsftO7TZdrJaDGsTtQq0C0HO0WsGdi_45R9BTMcMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmHOzaMVWMbIj54oPPEtTRjvEpqIP2NjVooyWGZDF6eBsMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completedko1ktByvOrZo7LXxf3BdgA11fVs5vgiyHF7xsJRQOkMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerX_qe0R1yiUa1SnRFSnPbO3eqFESxn_SBZdNBL5XwOIgMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmmCV9rEnPy2EsBOWlSGJW_hP0u68kZqO_4599Wc3CME3j4Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codefxvMmXqQDvvHIc6anyPNzV5NQISPLzoJMAl2uzqwwg0Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeVLpNp_wo1dmp0tnNOWLaYg1QbhvmI2jINRFE5pWc9TIMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeaGCkXFxCh6MWSmnfYmRvOTo7T6i6Gw0EfjQobRDcGckMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registertoVxlpChC2NexQufy0JErAPFY33ocEtIDBjH3_6gceQMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmA8hD1UvSKYZbZBhvIVI2XcZ8Rl1lt2u0ZaBvwsEGpaUMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeNAhaNh9lsuDKPGRPjgvYqwwIU5tsjD6PSzxNFfjdMfQMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexsWNbxnu4GNTFRJUCFgSOzb6HZmua_45sTqhZkKytERPgwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete8SgzySZFFpgBMbBr4TeMh6YCq5KVYAM_C5UGEVxJkMoMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleISF_ANCrjeAt5Lt8O9SgB67SjfMaPnXZ9ITdr7cV0vMMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailGdebheBq9ELZbGPfnUIUv_45Xq4KqGDUL9BM5rk_45trJ1MMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmW3fPKwcgDjkgbT8kNflxgYq24G_45a8poz9aooWiBNKpQMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent_45tKKbORQRfM5YaxrCJX5MtOZhALcWkh_45YW_WbWOCTpcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmPEL9NCPEvFk5FI_sT_0AR6Nk7x_r5Z7OeQTE4ZzxUMwMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completen7gJZ7JlvtKnrKrOVZHF5g87eEnGWrPOk3TiY_RK0ZcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeQrpPRZQfk5LA6qC7YVLR6tTteQKrMF0oawMoitKcXqMMeta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordl7huRKBjMZCvBYcxpTCakRjRdAOKom8ECmbBhq4I418Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerH6HDrxZYOTvU2Nsf9hAwU_bonr_45nUCTLsIDg2L0k3d8Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeWLRU3_45964V2fccMTJT2h_Q_45SH5wn84I8OS1RiUF2yc0Meta || {},
    component: () => import("/codebuild/output/src3405017696/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3405017696/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]